.headerBox {
  align-items: center;
  justify-content: space-between;
}

.chordNameLabel {
  margin-right: 8px;
}

.noteChip {
  margin: 8px;
}

.tabs {
  margin-bottom: 16px;
}

.fretboard {
  min-width: 500px;
}
